// src/components/rodape/Rodape.js
import React from "react";
import "./Styles.css";

export default function Rodape() {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-about">
          <h3>Manutenção PC Pilar do Sul</h3>
          <p>Atendimento especializado em manutenção, formatação, upgrade e suporte técnico para computadores e notebooks.</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 Manutenção de Computadores Pilar do Sul | Rua Francisco Ferreira do Santos, 400 - Jardim Pinheiro, SP</p>
        <p>Contato: <a href="mailto:wellingtonmiranda23@yahoo.com">wellingtonmiranda23@yahoo.com</a> | <a href="tel:+5515996879862">+55 15 99687-9862</a></p>
      </div>
    </footer>
  );
}
